import { twMerge } from "tailwind-merge";

import { Loader } from "@components/ClinicalNewReportDialog/Loader";

const SectionSkeleton = () => (
  <div className="w-full h-96 rounded-3xl border border-limestone-100 flex flex-col items-center justify-start bg-white p-4 animate-pulse">
    <Loader />
  </div>
);

const SuggestionCardSkeleton = () => (
  <div className="w-full rounded-3xl bg-limestone-100 p-4 animate-pulse mb-4">
    <div className="flex flex-col items-start gap-3 space-y-2">
      <div className="h-8 w-full bg-limestone-200 rounded-sm"></div>
      <div className="h-2 w-full bg-limestone-200 rounded-sm"></div>
      <div className="h-2 w-3/4 bg-limestone-200 rounded-sm"></div>
      <div className="h-2 w-2/4 bg-limestone-200 rounded-sm"></div>
    </div>
  </div>
);

export const SuggestionCardSkeletons: React.FC<{ count?: number }> = ({ count = 6 }) =>
  Array.from({ length: count }, (_, index) => <SuggestionCardSkeleton key={index} />);

export const BlankState = () => (
  <div className="flex w-full flex-col bg-limestone-50">
    <div className="grid gap-x-1 grid-cols-4">
      <div className="col-span-3 flex w-full flex-col gap-y-4 relative">{/* Blank containers - no content */}</div>
    </div>
  </div>
);

export const SkeletonState: React.FC<{
  isReviewPanelVisible: boolean;
  suggestionsScrollRef: React.RefObject<HTMLDivElement | null>;
}> = ({ isReviewPanelVisible, suggestionsScrollRef }) => (
  <div className="flex w-full flex-col bg-limestone-50">
    <div className={twMerge("grid gap-x-2", isReviewPanelVisible ? "grid-cols-12 mt-10" : "grid-cols-4")}>
      <div className="col-span-8 flex w-full flex-col gap-y-4 relative">
        <SectionSkeleton />
        <SectionSkeleton />
        <SectionSkeleton />
      </div>
      {isReviewPanelVisible && (
        <div ref={suggestionsScrollRef as React.RefObject<HTMLDivElement>} className="w-full col-span-3">
          <div className="space-y-4">
            <SuggestionCardSkeletons />
          </div>
        </div>
      )}
    </div>
  </div>
);
